import { useState } from "react";
import { Button, Form, Image, Stack, Fade, Alert } from "react-bootstrap";
import Loading from "../components/Loading";
import { useAuth } from "../api/auth/store";
import Label from "../components/Label";
import { getErrorMessage } from "../utils/errors";
import { HTTP_OK } from "../constants";
import Logo from "../assets/images/logo.png";

const ForgotPage = () => {
  const { landingIcon, autologging, forgotPassword } = useAuth(state => state);
  const [email, setEmail] = useState("");
  const [errmsg, setErrmsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onSend = async () => {
    setErrmsg("");
    setLoading(true);
    setSuccess(false);
    // Simulate API call - Replace this with your actual forgot password logic
    // setTimeout(() => {
    //   // Example: Simulate success or failure
    //   const randomSuccess = Math.random() > 0.3; // 70% chance of success
    //   if (randomSuccess) {
    //     setSuccess(true);
    //   } else {
    //     setErrmsg("Failed to send reset link. Please try again later.");
    //   }
    //   setLoading(false);
    // }, 1500);
    const res = await forgotPassword(email);
    setLoading(false);
    switch (res) {
      case HTTP_OK:
        setSuccess(true);
        break;
      default:
        setErrmsg(getErrorMessage(res) || "Failed to reset password. Please try again later.");
        break;
    }
  };

  const updateInputs = (_email: string) => {
    setEmail(_email);
    setErrmsg("");
  };

  const logo = landingIcon ? landingIcon : Logo;

  return (
    <Stack className="login-box" gap={3}>
      <Image className="login-img" src={logo} />
      {success ? (
        <Stack gap={2} className="text-center">
          <Alert variant="success">
            <Label color="green" size="medium" fontWeight="600">
              Reset link sent!
            </Label>
          </Alert>
          <p className="text-muted">
            Please check your email (including spam folder) for instructions on how to reset your password.
          </p>
        </Stack>
      ) : (
        <>
          <Stack gap={2}>
            <Label size="large" fontWeight="600" textAlign="center">
              Forgot Password?
            </Label>
            <p className="text-muted text-center">
              Enter your username or email address below and we'll send you a link to reset your password.
            </p>
          </Stack>
          <Form.Control
            autoFocus
            disabled={loading}
            placeholder="Username or Email"
            type="text"
            value={email}
            onChange={(e) => updateInputs(e.target.value)}
          />
          {errmsg !== "" && (
            <Alert variant="danger" className="mt-2">
              {errmsg}
            </Alert>
          )}
          <Fade in={email !== ""}>
            <Button className="login-button" disabled={loading || email === ""} onClick={onSend}>
              {loading ? <Loading /> : "Send Reset Link"}
            </Button>
          </Fade>
        </>
      )}
    </Stack>
  );
};

export default ForgotPage;
